module.exports = __webpack_public_path__ + "img/GH-kyujin-website003.16c9ecf8.webp";